import React from "react";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../siteConfig";

export default function WhatWeCheckPage() {
  return (
    <div className="app page-grid">
      <Helmet>
        <title>What We Check | OptiSiteSEO</title>
        <meta
          name="description"
          content="We focus on technical SEO signals: indexing, crawlability, metadata, structured data, performance risk signals, analytics, measurement, and foundational discoverability checks."
        />
        <link rel="canonical" href={canonicalUrl("/what-we-check")} />
      </Helmet>

      <section className="card section page-hero">
        <p className="eyebrow">What we check</p>
        <h1>Signals that can affect technical SEO and visibility</h1>
        <p className="subtext">Public-site checks that help prioritize technical visibility fixes, not vanity grading or broad strategy claims.</p>
        <div className="cta-row">
          <a className="primary" href="/app/index.html">
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            See a sample report
          </a>
        </div>
      </section>

      <section className="card section page-card">
        <ul className="bullets">
          <li>Indexability signals: robots, canonicals, redirects</li>
          <li>Metadata and structured data: titles, descriptions, OpenGraph, schema basics</li>
          <li>Performance risk: Core Web Vitals hints (LCP/CLS)</li>
          <li>Foundations: sitemap, HTTPS, reachability, status codes</li>
        </ul>
      </section>
    </div>
  );
}
